import React from 'react';
import { I18nextProvider } from 'react-i18next';
import Bugsnag from '@bugsnag/js';
import az from './locales/az.json';
import ru from './locales/ru.json';
import { GlobalStyles } from '../sharedNewEditAdPage/styles';

document.addEventListener('DOMContentLoaded', async () => {
  const container = document.getElementById('new-ad-app');
  if (container) {
    try {
      const [{ createRoot }, { ContextWrapper }, { customizeI18n }, { Content }] =
        await Promise.all([
          import('react-dom/client'),
          import('./context/ContextWrapper'),
          import('../utils/i18n'),
          import('./components/Content')
        ]);
      const i18n = customizeI18n({ az, ru });
      const dataset = JSON.parse(JSON.stringify(container.dataset));

      createRoot(container).render(
        <I18nextProvider {...{ i18n }}>
          <ContextWrapper {...{ dataset }}>
            <GlobalStyles />
            <Content />
          </ContextWrapper>
        </I18nextProvider>
      );
    } catch (error) {
      console.error('Error initializing new-ad-app:', error);
      Bugsnag.notify(error);
    }
  }
});
